/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'

const LEASE_BASE_LINK = '/admin/leases'

export function getLeaseCreateLink (params?: Record<string, unknown>) {
  return `${LEASE_BASE_LINK}/create?${stringify(params)}`
}

export function getLeaseLink (id: number | string) {
  return `${LEASE_BASE_LINK}/${id}/edit`
}

export function getLeaseInterventionListLink (id: number | string) {
  return `${LEASE_BASE_LINK}/${id}/interventions`
}

export function getLeaseInvoiceListLink (id: number | string) {
  return `${LEASE_BASE_LINK}/${id}/invoices`
}

export function getLeaseManagementReportListLink (id: number | string) {
  return `${LEASE_BASE_LINK}/${id}/management-reports`
}

export function getLeaseRentalReportListLink (id: number | string) {
  return `${LEASE_BASE_LINK}/${id}/rental-reports`
}

export function getLeaseListLink (params?: Record<string, unknown>) {
  return `${LEASE_BASE_LINK}?${stringify(params)}`
}
